export default {
    apiKey: "AIzaSyAV4sw9t2zV-k-HbV17QF5xQYDSnp07AbQ",
    authDomain: "ayun-pjl.firebaseapp.com",
    projectId: "ayun-pjl",
    storageBucket: "ayun-pjl.appspot.com",
    messagingSenderId: "941041535014",
    appId: "1:941041535014:web:0c0f31de91e1c0f469bee7",
    measurementId: "G-KX9NT70TK5"
};
